module.exports = __webpack_public_path__ + "img/1F63F.f4be12e6.svg";